import { CheckboxGroupRenderer } from '../components/CheckboxGroupRenderer';
import { RadioGroupRenderer } from '../components/RadioGroupRenderer';
import { EPreciseFilterTypes } from '../../../types/redux/preciseFilters';

export const optionsRenderers = {
  [EPreciseFilterTypes.Checkbox]: CheckboxGroupRenderer,
  [EPreciseFilterTypes.RadioButton]: RadioGroupRenderer,
};
